import { getAttendConfig, updateAttendGroup } from '../services';

export default {
  namespace: 'attendanceConfig',
  state: {},
  effects: {
    *getAttendConfig({ payload }, { call }) {
      const res = yield call(getAttendConfig, payload);
      return res;
    },
    *updateAttendGroup({ payload }, { call }) {
      const res = yield call(updateAttendGroup, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
